var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53033 2.46967C6.23744 2.17678 5.76257 2.17678 5.46967 2.46967C5.17678 2.76256 5.17678 3.23743 5.46967 3.53033L6.53033 2.46967ZM5.46967 12.4697C5.17678 12.7626 5.17678 13.2374 5.46967 13.5303C5.76256 13.8232 6.23743 13.8232 6.53033 13.5303L5.46967 12.4697ZM10.6464 7.64649L10.1161 8.17681L10.6464 7.64649ZM10.6464 8.35359L11.1768 8.88393L10.6464 8.35359ZM5.46967 3.53033L10.1161 8.17681L11.1768 7.11616L6.53033 2.46967L5.46967 3.53033ZM10.1161 7.82326L5.46967 12.4697L6.53033 13.5303L11.1768 8.88393L10.1161 7.82326ZM10.1161 8.17681C10.0185 8.07918 10.0185 7.92089 10.1161 7.82326L11.1768 8.88393C11.6649 8.39577 11.6649 7.60431 11.1768 7.11616L10.1161 8.17681Z",
    fill: "#B1B8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow_Right.4de6637397f16cd582526fb7d22c258e.svg";
export { ForwardRef as ReactComponent };